/* src/app/ibm-bot/bot.component.scss */
.chat-bot {
  position: relative;
}
.chat-bot .quickview {
  margin: 80px 0px;
}
.chat-bot .quickview .quickview-header {
  min-height: 40px !important;
}
.chat-bot .quickview .quickview-body {
  overflow-x: hidden;
}
.chat-bot .quickview .quickview-body .quickview-block {
  padding-top: 25px;
}
.chat-bot .quickview .quickview-body .quickview-block .column {
  padding: 0 0.75rem;
}
.chat-bot .chat-bot-btn {
  position: absolute;
  right: 30px;
  bottom: 150px;
  z-index: 10015;
}
.talk-bubble {
  margin: 4px 32px;
  display: inline-block;
  position: relative;
  width: auto;
  height: auto;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.border {
  border: 8px solid #666;
}
.tri-right.border.left-top:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -40px;
  right: auto;
  top: -8px;
  bottom: auto;
  border: 32px solid;
  border-color: #666 transparent transparent transparent;
}
.tri-right.left-top:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 22px solid;
  border-color: #d9edf7 transparent transparent transparent;
}
.tri-right.border.right-in:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -40px;
  top: 30px;
  bottom: auto;
  border: 20px solid;
  border-color: #666 transparent transparent #666;
}
.tri-right.right-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 12px solid;
  border-color: #d9edf7 transparent transparent #d9edf7;
}
.right-chat {
  right: 0;
  position: absolute;
  display: block;
}
.left-chat {
  left: 0;
  position: absolute;
  display: block;
}
.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}
.talktext p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}
/*# sourceMappingURL=bot.component.css.map */
